export const nonFalse = <T>(v: T): v is T extends false ? never : T => !!v;

export const isPastApproval = (
  timesheet:
    | {
        submittedAtTimesheet?: { pastApprovalDeadline: boolean } | null;
        status: string;
      }
    | undefined
) => {
  const pastApprovalDeadline =
    timesheet?.submittedAtTimesheet?.pastApprovalDeadline || false;

  return pastApprovalDeadline && timesheet?.status === 'submitted';
};
